import type { UseFormRegisterReturn } from 'react-hook-form';

/**
 * Adapts a react-hook-form registration to a reactstrap `<Input>`.
 *
 * `register()` returns the DOM ref under `ref`, which on a reactstrap `Input`
 * would resolve to the React component rather than the underlying `<input>`.
 * react-hook-form would then never see a value: the field stays empty, and the
 * form fails its own required checks while the user looks at the text they
 * just typed. Reactstrap forwards `innerRef` to the real element, so the ref
 * moves there.
 *
 * Use for every reactstrap-backed field:
 *
 *     <Input id="email" {...rhfInput(register('email'))} />
 */
export const rhfInput = ({ ref, ...rest }: UseFormRegisterReturn) => ({
  innerRef: ref,
  ...rest,
});

export default rhfInput;
